<template>
  <div class="pagination-wrapper">
    <el-pagination
      background
      layout="prev, pager, next, slot, jumper"
      :style="{textAlign: align, paddingTop: `${pTop}px`}"
      :hide-on-single-page="true"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <span class="total-page">共 {{ Math.ceil(total / pageSize) }} 页</span>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
    align: {
      type: String,
      default: 'center',
    },
    pTop: {
      type: Number,
      default: 40,
    },
  },
  methods: {
    handleSizeChange(size) {
      this.$emit('size-change', size);
    },
    handleCurrentChange(page) {
      this.$emit('current-change', page);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/variables'
.pagination-wrapper
  >>>.total-page
    height 32px
    line-height 32px
    font-size 12px
    font-weight 400
    margin-left 10px
  >>>.el-pagination__jump
    display inline-flex
    align-items center
    flex-flow row nowrap
    height 32px
    line-height 32px
    margin-left 10px
    font-size 12px
    color #333333
  >>>.el-pagination.is-background .btn-next,
  >>>.el-pagination.is-background .btn-prev,
  >>>.el-pagination.is-background .el-pager li
    width 32px
    height 32px
    line-height 32px
    text-align center
    background-color #ffffff
    border 1px solid #D9D9D9
    font-weight 400
    border-radius 4px
  >>>.el-pagination.is-background .el-pager li:not(.disabled).active
    background-color $theme
    border none
</style>
